export const CheckBoxChecked = {
  yes: 'yes',
  no: 'no'
};

export const DEFAULT_FORMFIELD_APRETUDE = {
  drugAllergies: '',
  prescriberPracticeName: '',

  diagnosisDescription: '',

  'checkbox-pregnant': CheckBoxChecked.no,
  'checkbox-ntoth': false,
  'checkbox-conth': false,
  'checkbox-thch': false,

  'checkbox-insurance': true,

  'checkbox-should-cabotegravir': CheckBoxChecked.no,
  'checkbox-has-cabotegravir': '',
  'cabotegravirStartDate': '',
  'lastInjectionDate': '',
  'nextInjectionDate': '',

  'checkbox-asoc-on-site': true,
  'checkbox-pharmacist-may-administer': true,
  'checkbox-asoc-dose-type-a': false,
  'checkbox-asoc-dose-type-b': false,
  noOfPNRRefillsTypeA: '',
  noOfPNRRefillsTypeB: '',
};

export const DEFAULT_FORMFIELD_WHEN_FIELD_IS_MISSING = {
  prescriberPracticeName: 'Doctor Matrix Medical Group',
  prescriberFax: '855-710-6616',
  diagnosisDescription: 'HIV pre-exposure prophylaxis',
  icd10Diagnosis: 'Z29.81 modifier 33',
};

export const QID_DrugAllergiesInput = 'QID_DrugAllergiesInput';
export const QID_IsPatientPregnantCheckbox = 'QID_IsPatientPregnantCheckbox';
export const QID_CurrentlyTakingAppretudeCheckbox = 'QID_CurrentlyTakingAppretudeCheckbox';
export const PID_ShouldCabotegravir = 'PID_ShouldCabotegravir';
export const QID_LastInjectionDate = 'QID_LastInjectionDate';
